import { render, staticRenderFns } from "./MobilityDetail.vue?vue&type=template&id=384e5e2c&scoped=true"
import script from "./MobilityDetail.vue?vue&type=script&lang=js"
export * from "./MobilityDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384e5e2c",
  null
  
)

export default component.exports